exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mychips{background-color:#ccc!important;height:16px;width:55px;border-radius:2px;margin-right:5px;font-size:.7em;display:flex;align-items:center;justify-content:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-01b6b6f3","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/root/GerenciarRotas.vue
// module id = 1030
// module chunks = 0